<template>
    <div class="passengers--page">
      <el-card>
          <el-input placeholder="Ticket REF (XXXXXXXX)" v-model="ref" clearable />
            <br/>
            <br/>
        <el-button v-loading="loading" @click="onInjectPassenger" style="width: 100%" type="warning">
          Submit Reference
        </el-button>
        </el-card>
    </div>
</template>

<script>
import { injectPassenger } from '@/services/passenger'
export default {
  data () {
    return {
      loading: false,
      ref: ''
    }
  },

  methods: {
    onInjectPassenger () {
      this.loading = true
      const payload = { 'refs': this.ref }
      injectPassenger(payload)
        .then(res => {
          this.loading = true
          this.$notify({
            type: 'success',
            message: 'Passenger Reference Successly Added'
          })
          this.$router.push({
            name: 'Passengers'
          })
        })
        .catch(() => {
          this.loading = false
          this.$notify.error({
            title: 'Inject Passenger',
            message: 'Ticket Reference Not Valid'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkin {
  min-width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/passengers/InjectFailedPassenger.vue